import React, {useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import UserImageCircle from "../../UserImageCircle";
import {useAuth} from "../../../providers/AuthProvider";
import ScheduleMeetingModal from "../ScheduleMeetingModal";
import Meeting from '../../../models/Meeting';
import Popup from "../../../../js/plugins/Popup";
import MeetingPopup from "./MeetingPopup";
import {useIsMutating} from "@tanstack/react-query";
import {Modal, Dropdown} from "antd";


const OppMeetingRow = ({meeting, isOpen, onToggle, ...props}) => {
    const {auth} = useAuth();
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);


    const closeModal = () => setIsDetailsOpen(false);
    const popupContentRef = useRef(null);
    const [isScheduleMeetingOpen, setIsScheduleMeetingOpen] = useState(false)

    const isSavingMeeting = useIsMutating({mutationKey: ['confirmInterviewMutation']});

    const scheduleMeeting = (e) => {
        if (e) e.stopPropagation();

        return setIsScheduleMeetingOpen(true);
    }

    const openPopup = (event) => {
        setIsDetailsOpen(true);
    }

    const closeScheduleMeeting = async () => {
        return setIsScheduleMeetingOpen(false);
    }

    const canCancel = !meeting.hasExpired()
        && !meeting.rejected_at
        && meeting.status !== 'Completed'
        && auth.canManageTalentOppInterviews();

    const attendees = useMemo(() => {

        let members = [...meeting.members];
        return TB.filter(members, member => {
            return member.id !== meeting.creator.id
        });

    }, [meeting.status]);
    return (
        <React.Fragment>
            <Popup
                key={`open-meeting-${meeting.id}`}
                position={['center center', 'center right', 'center bottom', 'right center', 'right bottom', 'center center']}
                keepTooltipInside={'.proposal-container'}
                // ref={popupRef}
                closeOnDocumentClick
                open={isDetailsOpen}
                onOpen={openPopup}
                onClose={closeModal}
                on={['click']}
                trigger={
                    // <tr className="interview-row clickable" key={`meeting-${meeting.id}`}>
                    <tr className="interview-row clickable border-b last-of-type:border-none hover:bg-gray-100" key={`meeting-${meeting.id}`}>

                        <td scope="row">
                            <div className="interview-name">
                                <p className="text-xs line-clamp-2 text-ellipsis overflow-hidden max-w-[200px]">{meeting.name}</p>
                            </div>
                        </td>
                        <td>
                            {meeting.creator && (
                                <div className="flex flex-row items-center justify-start" style={{gap: 8}}>
                                    <UserImageCircle
                                        user={meeting.creator}
                                        hideTooltip={true}
                                        className="img-grayscale"
                                        size={36}/>
                                    {!!attendees.length && (
                                        <span className="attendee-count whitespace-no-wrap"
                                              id={`max-members-${meeting.id}`}>
                                        {`+You${attendees.length > 1 ? `, ${attendees.length - 1} more` : ''}`}
                                    </span>
                                    )}
                                </div>
                            )}
                        </td>
                        <td className="whitespace-nowrap">
                            {meeting.awaitingConfirmationByTalent() && auth.canManageTalentOppInterviews() && (
                                <button className="btn btn-primary text-xs" onClick={scheduleMeeting} disabled={props.disabled}>
                                    {meeting.rescheduled_at ? "Update Availability" : "Confirm Availability"}
                                </button>
                            )}
                            {!meeting.awaitingConfirmationByTalent() && (
                                <p className="text-xs">
                                    {meeting.acceptedTime()}
                                </p>
                            )}

                        </td>
                        <td>
                            <div className={"meeting-status whitespace-nowrap " + meeting.statusClass()}>
                                {meeting.statusName()}
                            </div>
                        </td>
                        <td>
                            {canCancel && (
                                <Dropdown
                                    menu={{
                                        items: [{ label: 'Cancel', key: 'Cancel' }],
                                        onClick: e => {
                                            e.domEvent.stopPropagation();
                                            if (e.key === 'Cancel') {
                                                props.onCancel(meeting.id, Meeting.talent_cancelled_reason()?.value)
                                            }
                                        },
                                        disabled: props.disabled,
                                    }} 
                                    trigger={['click']}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <i className="fas fa-ellipsis-v p-2 hover:bg-gray-200"/>
                                </Dropdown>
                            )}
                        </td>
                    </tr>
                }>
                <MeetingPopup
                    meeting={meeting}
                    viewerType="talent"
                    onConfirm={e => {
                        e.stopPropagation();
                        scheduleMeeting()
                    }}
                    onCancel={() => props.onCancel(meeting.id, Meeting.talent_cancelled_reason()?.value)}
                    onClose={() => closeModal()}
                    actionable={false}
                    canReschedule={false}
                    ref={popupContentRef}/>
            </Popup>

            <Modal
                okText={null}
                zIndex={199}
                footer={null}
                cancelText={null}
                title={null}
                className="schedule-meeting-modal talent-confirmation"
                open={isScheduleMeetingOpen}
                closeable={!isSavingMeeting?.length}
                maskClosable={!isSavingMeeting?.length}
                style={{top: 20}}
                destroyOnClose={true}
                width={900}
                onCancel={closeScheduleMeeting}>

                <ScheduleMeetingModal
                    meeting={meeting}
                    activeTalentCandidateId={props.activeTalentCandidateId}
                    opportunity={props.opportunity}
                    onClose={() => closeScheduleMeeting()}/>

            </Modal>

        </React.Fragment>
    )
};

OppMeetingRow.propTypes = {
    meeting: PropTypes.any
};

export default OppMeetingRow;